/**
 * ErrorUtil
 *
 * Created by Samuel on 2023/5/13
 */


export const ERROR_INFO = {
    '-2': {
        title: 'something error'
    },
    '-3': {
        title: 'data wrong'
    }
};
